import { FC, PropsWithChildren } from 'react';
import { Layout } from '@pcmp/react-coworker-components';

import { Header } from './header';
import NavBar from './nav-bar';
import { AppThemeListener } from '@/components/helpers/app-theme';
import { useGetAppConfigQuery } from '@/redux/back-dashboard-api';

export const PageLayout: FC<
  PropsWithChildren & {
    fullWidth?: boolean;
  }
> = ({ children, fullWidth }) => {
  return (
    <>
      <AppThemeListener />

      <Header fullWidth={fullWidth} />

      <>{children}</>

      <NavBar />
    </>
  );
};

const { Container } = Layout;

export const LayoutContainer: FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const { data } = useGetAppConfigQuery(undefined);
  const maintenanceEnabled = data?.appConfig?.maintenanceStatus?.enabled;

  return (
    <Container fullWidth>
      <div
        className="grid"
        style={{
          minHeight: `calc(100vh - ${maintenanceEnabled ? '120' : '72'}px)`,
          gridTemplateColumns: '350px 1fr',
        }}
      >
        {children}
      </div>
    </Container>
  );
};

export default PageLayout;
